import React from 'react';
import { TextInput, NumericInput, Checkbox } from '@leverege/ui-elements';
import Factory from '@leverege/factory';
export default new Factory({
  strategy: Factory.reactStrategy(React),
  registry: {
    number: NumericInput,
    string: TextInput,
    boolean: Checkbox
  },
  defaultObject: TextInput
});